import { Hub } from "@spilnu/game-comms";
import { defineNuxtPlugin } from "#app";
export default defineNuxtPlugin(() => {
  const hub = new Hub();
  return {
    provide: {
      gameHub: hub
    }
  };
});
